// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIntegrationCallsRequestModel from '../../model/get-integration-calls-request-model';
import GetIntegrationCallsRequestDTO from '../dto/get-integration-calls-request-dto';

export default abstract class GetIntegrationCallsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIntegrationCallsRequestDTO>) {
    super();
    if (data) {
      this.dateFrom = data.dateFrom;
      this.dateTo = data.dateTo;
      this.integrationTaskId = data.integrationTaskId;
      this.integrationStatusId = data.integrationStatusId;
      this.correlationId = data.correlationId;
      this.appTransactionId = data.appTransactionId;
      this.appUserId = data.appUserId;
      this.searchCriteria = data.searchCriteria;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  * @type {date-time}
  */
  'dateFrom'?: string;
  /**
  * @type {date-time}
  */
  'dateTo'?: string;
  /**
  * @type {int64}
  */
  'integrationTaskId'?: number;
  /**
  * @type {int64}
  */
  'integrationStatusId'?: number;
  /**
  */
  'correlationId'?: string;
  /**
  */
  'appTransactionId'?: string;
  /**
  * @type {int64}
  */
  'appUserId'?: number;
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetIntegrationCallsRequestDTO>): GetIntegrationCallsRequestModel;
  static toModel(dto: DeepPartial<GetIntegrationCallsRequestDTO> | undefined | null): GetIntegrationCallsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIntegrationCallsRequestDTO> | undefined | null): GetIntegrationCallsRequestModel | undefined {
    return dto ? new GetIntegrationCallsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIntegrationCallsRequestModel> | GetIntegrationCallsRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'dateFrom': unwrapped.dateFrom,
      'dateTo': unwrapped.dateTo,
      'integrationTaskId': unwrapped.integrationTaskId,
      'integrationStatusId': unwrapped.integrationStatusId,
      'correlationId': unwrapped.correlationId,
      'appTransactionId': unwrapped.appTransactionId,
      'appUserId': unwrapped.appUserId,
      'searchCriteria': unwrapped.searchCriteria,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetIntegrationCallsRequestDTO;
  }
}
